import GlobalVariable from '@/global/global-variable'

// 下载文件 NFC_ID 设备刷卡程序
const file_NFC_ID = GlobalVariable.PAGE_PATH + "/static/software/NFC_ID_Setup.zip";
// 下载文件 jkkcPlayer 视频播放器
const file_jkkcPlayer = GlobalVariable.PAGE_PATH + "/static/software/jkkcPlayer.zip";
// 下载文件 NFC_IDCard 身份证读卡程序
const file_NFC_IDCard = GlobalVariable.PAGE_PATH + "/static/software/ZKIDROnline.exe";
// 下载文件 人员上传模板
const file_user_upload_model = GlobalVariable.PAGE_PATH + "/static/template/user_upload_model.xlsx";
// 下载文件 车辆上传模板
const file_car_upload_model = GlobalVariable.PAGE_PATH + "/static/template/car_upload_model.xlsx";
// 下载文件 标签上传模板
const file_tag_upload_model = GlobalVariable.PAGE_PATH + "/static/template/tag_upload_model.xlsx";
// 下载文件 基站上传模板
const file_bs_upload_model = GlobalVariable.PAGE_PATH + "/static/template/bs_upload_model.xlsx";
// 下载文件 设备上传模板
const file_device_upload_model = GlobalVariable.PAGE_PATH + "/static/template/device_upload_model.xlsx";
// 下载文件 视频上传模板
const file_video_upload_model = GlobalVariable.PAGE_PATH + "/static/template/video_upload_model.xlsx";

export default {
    // 下载文件 NFC_ID 设备刷卡程序
    file_NFC_ID,
    // 下载文件 jkkcPlayer 视频播放器
    file_jkkcPlayer,
    // 下载文件 NFC_IDCard 身份证读卡程序
    file_NFC_IDCard,
    // 下载文件 人员上传模板
    file_user_upload_model,
    // 下载文件 车辆上传模板
    file_car_upload_model,
    // 下载文件 标签上传模板
    file_tag_upload_model,
    // 下载文件 基站上传模板
    file_bs_upload_model,
    // 下载文件 设备上传模板
    file_device_upload_model,
    // 下载文件 视频上传模板
    file_video_upload_model,
}



// WEBPACK FOOTER //
// ./src/request/api-file-local.js